/* eslint-disable no-unused-vars */
import store from "@/store";
const THREE = window.THREE;
import { addToScene, removeFromScene, distanceToPointToRelativeDistance, getScreenSpaceSize } from "../utils/forgeUtils";

/** Converts meter-scale constants to view-space scale. Returns 1 for meters, 1000 for mm. */
function getViewScaleFactor() {
    const unitScale = store.state.unitScale;
    if (!unitScale || unitScale <= 0) return 1;
    return 1 / unitScale;
}

var tempBox = null;
export function drawBox_Temp(box3){
    if(tempBox){
        tempBox.material.dispose();
        tempBox.geometry.dispose();
        store.state.viewer.impl.overlayScenes.pivot.scene.remove(tempBox);
    }
    if(!box3)
        return null;
    let geom = new THREE.Geometry();
    geom.vertices = [
        box3.min,new THREE.Vector3(box3.min.x,box3.max.y,box3.min.z),
        new THREE.Vector3(box3.min.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.max.y,box3.min.z),
        new THREE.Vector3(box3.max.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.min.y,box3.min.z),
        new THREE.Vector3(box3.max.x,box3.min.y,box3.min.z),box3.min,

        new THREE.Vector3(box3.min.x,box3.min.y,box3.max.z),new THREE.Vector3(box3.min.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.min.x,box3.max.y,box3.max.z),new THREE.Vector3(box3.max.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.max.y,box3.max.z),new THREE.Vector3(box3.max.x,box3.min.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.min.y,box3.max.z),new THREE.Vector3(box3.min.x,box3.min.y,box3.max.z),

        box3.min,new THREE.Vector3(box3.min.x,box3.min.y,box3.max.z),
        new THREE.Vector3(box3.min.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.min.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.min.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.min.y,box3.max.z),

    ];
    let mesh = new THREE.Line(geom,new THREE.MeshBasicMaterial({ color: 0xff0000 ,opacity:.3}),THREE.LinePieces);
    tempBox = mesh;
    store.state.viewer.impl.overlayScenes.pivot.scene.add(mesh);
    store.state.viewer.impl.invalidate(true, true, true);
    return mesh;
}
export function drawBoxLines(box3, color,viewer,sceneName) {
    let geom = new THREE.Geometry();
    geom.vertices = [
        box3.min,new THREE.Vector3(box3.min.x,box3.max.y,box3.min.z),
        new THREE.Vector3(box3.min.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.max.y,box3.min.z),
        new THREE.Vector3(box3.max.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.min.y,box3.min.z),
        new THREE.Vector3(box3.max.x,box3.min.y,box3.min.z),box3.min,

        new THREE.Vector3(box3.min.x,box3.min.y,box3.max.z),new THREE.Vector3(box3.min.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.min.x,box3.max.y,box3.max.z),new THREE.Vector3(box3.max.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.max.y,box3.max.z),new THREE.Vector3(box3.max.x,box3.min.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.min.y,box3.max.z),new THREE.Vector3(box3.min.x,box3.min.y,box3.max.z),

        box3.min,new THREE.Vector3(box3.min.x,box3.min.y,box3.max.z),
        new THREE.Vector3(box3.min.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.min.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.max.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.max.y,box3.max.z),
        new THREE.Vector3(box3.max.x,box3.min.y,box3.min.z),new THREE.Vector3(box3.max.x,box3.min.y,box3.max.z),
    ];
    let material = new THREE.MeshBasicMaterial({ color: color, depthTest: false, depthWrite: false,side:2 });
    let mesh = new THREE.Line(geom,material , THREE.LinePieces);
    mesh.name = 'BoxLines'
    addToScene(mesh,viewer,sceneName);
    return mesh;
}
export function drawBox3(boundingBox3, color, viewer, sceneName, opacity) {
    let width = boundingBox3.max.x - boundingBox3.min.x;
    let length = boundingBox3.max.y - boundingBox3.min.y;
    let height = boundingBox3.max.z - boundingBox3.min.z;
    const box = new THREE.BoxGeometry(width, length, height);
    let mesh = new THREE.Mesh(
        box,
        new THREE.MeshBasicMaterial({ color: color, opacity: opacity })
    );
    mesh.position.x = boundingBox3.min.x + 0.5 * width;
    mesh.position.y = boundingBox3.min.y + 0.5 * length;
    mesh.position.z = boundingBox3.min.z + 0.5 * height;
    addToScene(mesh, viewer, sceneName);
    return mesh;

}
export function drawPolygon(vertices,color,viewer,sceneName,alpha = 0.2){
    const shape = new THREE.Shape();
    for (let i = 0; i < vertices.length; i++) {
        shape.moveTo(vertices[i].x, vertices[i].y);
    }
    const geometry = new THREE.ShapeGeometry(shape);
    const material = new THREE.MeshBasicMaterial({ color: color,depthTest: false, depthWrite: false, transparent: true, opacity:alpha });
    const mesh = new THREE.Mesh(geometry, material);
    addToScene(mesh, viewer, sceneName)
    return mesh;
}
export function drawLine(p1,p2,color,viewer,sceneName){
    let geom = new THREE.Geometry();
    geom.vertices = [p1,p2];
    let mesh = new THREE.Line(geom,new THREE.MeshBasicMaterial({ color: color,depthTest: false, depthWrite: false}),THREE.LinePieces);
    addToScene(mesh,viewer,sceneName)
    return mesh;
}
export function drawRay(start, end, secondary = false) {
    let color1 = secondary ? 0x0000ff : 0xff0000;
    let color2 = secondary ? 0x00ff00 : 0x00ff00;

    drawLine(start, end.clone(), color1, store.state.viewer, 'test-overlay');

    const scaleFactor = getViewScaleFactor();
    const sphereGeometry = new THREE.SphereGeometry(0.03 * scaleFactor, 32, 32);
    const sphereMaterial = new THREE.MeshBasicMaterial({ color: color1, depthTest: false });
    const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
    sphere.position.copy(end);
    addToScene(sphere, store.state.viewer, 'test-overlay');

    const pointGeometry = new THREE.SphereGeometry(0.01 * scaleFactor, 32, 32);
    const pointMaterial = new THREE.MeshBasicMaterial({ color: color2, depthTest: false });
    const point = new THREE.Mesh(pointGeometry, pointMaterial);
    point.position.copy(end);
    addToScene(point, store.state.viewer, 'test-overlay');
}
export function drawArea2d(points,viewer,sceneName , color){

    let info = {}
    info.polyBorderGl = []
    for(let i = 0;i<points.length-1;i++){
        let lineGl = drawLine(points[i],points[i+1], color, viewer, sceneName);
        info.polyBorderGl.push(lineGl);
    }
    if(points.length > 2)
        info.tempPolyGl = drawPolygon(points, color, viewer, sceneName);
    return info;
}
export function disposeArea2d(areaInfo,viewer,sceneName){
    if(!areaInfo)
        return
    removeFromScene(areaInfo.polyBorderGl,viewer,sceneName);
    removeFromScene(areaInfo.tempPolyGl,viewer,sceneName);
}
export function isSamePoint(p1,p2,tolerance=.001){
    if (!p1 || !p2) return false;

    p1 = new THREE.Vector3(p1.x, p1.y, p1.z);
    p2 = new THREE.Vector3(p2.x, p2.y, p2.z);

    return p1.distanceTo(p2) < tolerance;
}
export function isSameNumber(num1,num2,tolerance=.001){
    return Math.abs(num1-num2)<tolerance;
}
export function getBoxOffset(box, offset){
    if (!box) return box;
    let newMin = new THREE.Vector3(box.min.x - offset, box.min.y - offset,box.min.z - offset)
    let newMax = new THREE.Vector3(box.max.x + offset, box.max.y + offset,box.max.z + offset)
    return new THREE.Box3(newMin, newMax)
}
export function isLeft(pt,a , b){
    return ((b.x - pt.x)*(a.y - pt.y) - (b.y - pt.y)*(a.x - pt.x)) > 0;
}
export function midpoint(pt1, pt2) {
    return new THREE.Vector3((pt1.x + pt2.x) / 2,(pt1.y + pt2.y) / 2,(pt1.z + pt2.z) / 2);
}
export function toPoint2D(point3) {
    return new THREE.Vector3(point3.x, point3.y, 0);
}
export function getNormal2D(point) {
    return new THREE.Vector3(-point.y, point.x, 0);
}
export function drawPoint2D(point, color,viewer,sceneName) {
    const scaleFactor = getViewScaleFactor();
    const ptSize = 0.01 * scaleFactor;
    const box = new THREE.BoxGeometry(ptSize, ptSize, ptSize);
    let mesh = new THREE.Mesh(
        box,
        new THREE.MeshBasicMaterial({ color: color })
    );
    mesh.position.x = point.x;
    mesh.position.y = point.y;
    mesh.position.z = 1;
    addToScene(mesh,viewer,sceneName);
    return mesh;
}
export function drawRectangle2D(min, max, color,viewer,sceneName) {
    let geom = new THREE.Geometry();
    geom.vertices = [
        new THREE.Vector3(min.x,min.y,1),
        new THREE.Vector3(max.x,min.y,1),
        
        new THREE.Vector3(max.x,min.y,1),
        new THREE.Vector3(max.x,max.y,1),
    
        new THREE.Vector3(max.x,max.y,1),
        new THREE.Vector3(min.x,max.y,1),
        
        new THREE.Vector3(min.x,max.y,1),
        new THREE.Vector3(min.x,min.y,1),
    ];
    let material = new THREE.MeshBasicMaterial({ color: color });
    let mesh = new THREE.Line(geom,material , THREE.LinePieces);
    addToScene(mesh,viewer,sceneName);
    return mesh;
}
export function drawPoint(point, color,viewer,sceneName,size) {
    if(!size)
        size = distanceToPointToRelativeDistance(point);
    const box = new THREE.BoxGeometry(size,size,size);
    let mesh = new THREE.Mesh(
        box,
        new THREE.MeshBasicMaterial({ color: color ,depthTest: false, depthWrite: false})
    );
    mesh.position.x = point.x;
    mesh.position.y = point.y;
    mesh.position.z = point.z;
    mesh.geometry.computeBoundingBox()
    addToScene(mesh,viewer,sceneName);
    return mesh;
}
export function drawTriangles(vertices, color,viewer,sceneName,alpha = 0.2) {
    var geometry = new THREE.Geometry();
    geometry.vertices = vertices;

    for (var i = 0; i < vertices.length; i += 3) {
        geometry.faces.push(new THREE.Face3(i, i + 1, i + 2));
    }

    var material = new THREE.MeshBasicMaterial({ color: color, transparent: true, opacity:alpha, side :2 });
    let mesh = new THREE.Mesh(geometry, material);
    addToScene(mesh,viewer,sceneName);
    return mesh;
}
//https://stackoverflow.com/questions/15139649/three-js-two-points-one-cylinder-align-issue/15160850#15160850
export function drawCylinder(vstart, vend,bottomRadius,topRadius, color,viewer,sceneName) {
    var HALF_PI = +Math.PI * .5;
    var distance = vstart.distanceTo(vend);
    var position = vend.clone().add(vstart).divideScalar(2);

    var material = new THREE.MeshBasicMaterial({ color: color, depthTest: false, depthWrite: false });
    var cylinder = new THREE.CylinderGeometry(bottomRadius,topRadius, distance, 10, 10, false);

    var orientation = new THREE.Matrix4();//a new orientation matrix to offset pivot
    var offsetRotation = new THREE.Matrix4();//a matrix to fix pivot rotation
    var offsetPosition = new THREE.Matrix4();//a matrix to fix pivot position
    orientation.lookAt(vstart, vend, new THREE.Vector3(0, 1, 0));//look at destination
    offsetRotation.makeRotationX(HALF_PI);//rotate 90 degs on X
    orientation.multiply(offsetRotation);//combine orientation with rotation transformations
    cylinder.applyMatrix(orientation);

    var mesh = new THREE.Mesh(cylinder, material);
    mesh.position.set(position.x, position.y, position.z);
    mesh.name = "cylinder";
    addToScene(mesh, viewer, sceneName);
    return mesh;
}

export function drawAxisArrow(dir,origin,color,viewer,sceneName, scale = 1, boxInfo = null){
    // Adaptive sizing: combine screen-space and crop-box-proportional sizing
    let size;
    
    if (boxInfo) {
        // Calculate screen-space size
        const desiredScreenSize = 10; // Desired size in screen pixels
        const screenSpaceSize = getScreenSpaceSize(origin, desiredScreenSize);
        
        // Calculate crop-box-proportional size (1-3% of average dimension)
        const arrowSizeRatio = 0.015; // 1.5% of average crop box dimension
        const boxProportionalSize = boxInfo.avgDimension * arrowSizeRatio;
        
        // Use the smaller of the two to ensure arrows aren't too large relative to box
        // But ensure minimum visibility
        const minVisibleSize = boxInfo.minDimension * 0.005; // 0.5% of smallest dimension
        size = Math.max(minVisibleSize, Math.min(screenSpaceSize, boxProportionalSize)) * scale;
    } else {
        // Fallback: use screen-space sizing only
        const desiredScreenSize = 10;
        size = getScreenSpaceSize(origin, desiredScreenSize) * scale;
    }
    
    // Clamp size to reasonable bounds, scaled by unit system
    const scaleFactor = getViewScaleFactor();
    const minSize = 0.003 * scaleFactor;  // meters: 0.003, mm: 3.0
    const maxSize = 0.3 * scaleFactor;    // meters: 0.3,   mm: 300
    if (size < minSize) size = minSize;
    if (size > maxSize) size = maxSize;
    
    // Any scale you need to add to the height of the arrow, add it as scale factor to the size.
    let pt2 = origin.clone().add(dir.clone().multiplyScalar(size * 8));
    let height = origin.distanceTo(pt2);
    let radius = size / 2;
    let arrow = new THREE.ArrowHelper(dir, origin, height, color);
    arrow.cone.geometry = new THREE.CylinderGeometry(0, 5, 2, 12);
    arrow.cone.material.depthTest = false;
    arrow.cone.material.depthWrite = false;
    arrow.line.material.depthTest = false;
    arrow.line.material.depthWrite = false;
    arrow.name = "arrow";

    addToScene(arrow, viewer, sceneName);

    // A cover for arrow's line to increase its radius.
    let cylinder = drawCylinder(origin, pt2, radius, radius, color, viewer, sceneName);

    return { arrow: arrow, cylinder: cylinder };
}

export function getBoxAroundPoint(point, width, depth, height) {
    width = store.state.forgeService.worldToView3dLength(width);
    depth = store.state.forgeService.worldToView3dLength(depth);
    height = store.state.forgeService.worldToView3dLength(height);

    let min = new THREE.Vector3();
    let max = new THREE.Vector3();

    min.x = point.x - width / 2.0;
    max.x = point.x + width / 2.0;
    min.y = point.y - depth / 2.0;
    max.y = point.y + depth / 2.0;
    min.z = point.z - height / 2.0;
    max.z = point.z + height / 2.0;
    
    return new THREE.Box3(min,max);
}

export function toRad(degree){
    return degree * Math.PI / 180;
}
export function toDegree(x) {
    return x * 180 / Math.PI;
}
export function toReal(x){
	if (!isNaN(parseFloat(x)) && isFinite(parseFloat(x)))
	{
		return parseFloat(parseFloat(x).toFixed(7));
	}
	else
	{
		return x;
	}
}
// Modified from https://stackoverflow.com/questions/22521982/check-if-point-is-inside-a-polygon
// point => K.Vector3
// vs    => array of K.Vector3
export function isPointInsidePolygon(point, vs) {
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
        
    var inside = false;

    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i].x, yi = vs[i].y;
        var xj = vs[j].x, yj = vs[j].y;
        
        var intersect = ((yi > point.y) != (yj > point.y))
            && (point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    
    return inside;
}
export function createForgeMaterial (viewer, color, opacity, transparent) {
    if (/^#([0-9a-fA-F]{6,8})$/.test(color)) {
        color = color.substring(0, 7);
    }

    const material = new THREE.MeshPhongMaterial({ transparent, opacity, color });
    const materials = viewer.impl.getMaterials()
    materials.addMaterial(color, material, true);
    return material;
}
export function getBoxControlArrows(controlBox, viewer, sceneName, scale = 1) {
    let center = controlBox.getCenter();
    
    // Calculate crop box size for adaptive scaling
    const boxSize = controlBox.getSize(new THREE.Vector3());
    const minDimension = Math.min(boxSize.x, boxSize.y, boxSize.z);
    const maxDimension = Math.max(boxSize.x, boxSize.y, boxSize.z);
    const avgDimension = (minDimension + maxDimension) / 2;
    
    // Store box size info for adaptive arrow sizing
    const boxInfo = {
        minDimension: minDimension,
        maxDimension: maxDimension,
        avgDimension: avgDimension,
        center: center
    };

    let controlPoints = [
        {
            type: 'Front', point: new THREE.Vector3(center.x, controlBox.min.y, center.z), dir: new THREE.Vector3(0, -1, 0), color: 0xff0000, highlight: (color = 0x0000ff) => {
                let pt1 = controlBox.min;
                let pt2 = new THREE.Vector3(controlBox.min.x, controlBox.min.y, controlBox.max.z);
                let pt3 = new THREE.Vector3(controlBox.max.x, controlBox.min.y, controlBox.max.z);
                let pt4 = new THREE.Vector3(controlBox.max.x, controlBox.min.y, controlBox.min.z);

                let trianglePoints = [pt1, pt2, pt3, pt1, pt3, pt4];
                return drawTriangles(trianglePoints, color, viewer, sceneName);
            }
        },
        {
            type: 'Back', point: new THREE.Vector3(center.x, controlBox.max.y, center.z), dir: new THREE.Vector3(0, 1, 0), color: 0xff0000, highlight: (color = 0x0000ff) => {
                let pt1 = new THREE.Vector3(controlBox.min.x, controlBox.max.y, controlBox.min.z);
                let pt2 = new THREE.Vector3(controlBox.min.x, controlBox.max.y, controlBox.max.z);
                let pt3 = controlBox.max;
                let pt4 = new THREE.Vector3(controlBox.max.x, controlBox.max.y, controlBox.min.z);

                let trianglePoints = [pt1, pt2, pt3, pt1, pt3, pt4];
                return drawTriangles(trianglePoints, color, viewer, sceneName);
            }
        },
        {
            type: 'Left', point: new THREE.Vector3(controlBox.min.x, center.y, center.z), dir: new THREE.Vector3(-1, 0, 0), color: 0x00ff00, highlight: (color = 0x0000ff) => {
                let pt1 = controlBox.min;
                let pt2 = new THREE.Vector3(controlBox.min.x, controlBox.min.y, controlBox.max.z);
                let pt3 = new THREE.Vector3(controlBox.min.x, controlBox.max.y, controlBox.max.z);
                let pt4 = new THREE.Vector3(controlBox.min.x, controlBox.max.y, controlBox.min.z);

                let trianglePoints = [pt1, pt2, pt3, pt1, pt3, pt4];
                return drawTriangles(trianglePoints, color, viewer, sceneName);
            }
        },
        {
            type: 'Right', point: new THREE.Vector3(controlBox.max.x, center.y, center.z), dir: new THREE.Vector3(1, 0, 0), color: 0x00ff00, highlight: (color = 0x0000ff) => {
                let pt1 = new THREE.Vector3(controlBox.max.x, controlBox.min.y, controlBox.max.z);
                let pt2 = new THREE.Vector3(controlBox.max.x, controlBox.min.y, controlBox.min.z);
                let pt3 = new THREE.Vector3(controlBox.max.x, controlBox.max.y, controlBox.min.z)
                let pt4 = controlBox.max;

                let trianglePoints = [pt1, pt2, pt3, pt1, pt3, pt4];
                return drawTriangles(trianglePoints, color, viewer, sceneName);
            }
        },
        {
            type: 'Top', point: new THREE.Vector3(center.x, center.y, controlBox.max.z), dir: new THREE.Vector3(0, 0, 1), color: 0x0000ff, highlight: (color = 0x0000ff) => {
                let pt1 = new THREE.Vector3(controlBox.min.x, controlBox.min.y, controlBox.max.z);
                let pt2 = new THREE.Vector3(controlBox.max.x, controlBox.min.y, controlBox.max.z);
                let pt3 = controlBox.max;
                let pt4 = new THREE.Vector3(controlBox.min.x, controlBox.max.y, controlBox.max.z);

                let trianglePoints = [pt1, pt2, pt3, pt1, pt3, pt4];
                return drawTriangles(trianglePoints, color, viewer, sceneName);
            }
        },
        {
            type: 'Bottom', point: new THREE.Vector3(center.x, center.y, controlBox.min.z), dir: new THREE.Vector3(0, 0, -1), color: 0x0000ff, highlight: (color = 0x0000ff) => {
                let pt1 = controlBox.min;
                let pt2 = new THREE.Vector3(controlBox.max.x, controlBox.min.y, controlBox.min.z);
                let pt3 = new THREE.Vector3(controlBox.max.x, controlBox.max.y, controlBox.min.z);
                let pt4 = new THREE.Vector3(controlBox.min.x, controlBox.max.y, controlBox.min.z);

                let trianglePoints = [pt1, pt2, pt3, pt1, pt3, pt4];
                return drawTriangles(trianglePoints, color, viewer, sceneName);
            }
        },
    ];

    controlPoints.forEach(o=>{
        o.arrow = drawAxisArrow(o.dir, o.point, o.color, viewer, sceneName, scale, boxInfo);
    });

    return controlPoints;
}

export function createBoxAroundPoint(point, radius = 1) {
    // Ensure point is a THREE.Vector3 object
    if (!(point instanceof THREE.Vector3)) {
        point = new THREE.Vector3(point.x, point.y, point.z);
    }

    // Ensure radius is a number
    if (typeof radius !== 'number') {
        radius = parseFloat(radius);
    }

    // Create the box
    let p1 = new THREE.Vector3(point.x - radius, point.y - radius, point.z - radius);
    let p2 = new THREE.Vector3(point.x + radius, point.y + radius, point.z + radius);

    let box = new THREE.Box3().setFromPoints([p1, p2]);

    return box;
}

export function getBoxAroundPoints(points) {
    if (!points || !points.length) return null;

    let max = new THREE.Vector3(
        Math.max(...points.map((p) => p.x)),
        Math.max(...points.map((p) => p.y)),
        Math.max(...points.map((p) => p.z)),
    );
    let min = new THREE.Vector3(
        Math.min(...points.map((p) => p.x)),
        Math.min(...points.map((p) => p.y)),
        Math.min(...points.map((p) => p.z)),
    );

    return new THREE.Box3(min, max);
}